shadow$provide[183] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, DOM:{enumerable:true, get:function() {
  return DOM;
}}});
var VDOM = require("../util/vdom.js");
var require$_DOT__SLASH_overlay_DOT_js = require("./overlay.js");
class DOM extends require$_DOT__SLASH_overlay_DOT_js.Overlay {
  static initClass() {
    this.prototype.el = VDOM.element;
    this.prototype.hint = VDOM.hint;
    this.prototype.apply = VDOM.apply;
    this.prototype.recycle = VDOM.recycle;
  }
  init(_options) {
    return this.last = null;
  }
  dispose() {
    this.unmount();
    return super.dispose();
  }
  mount() {
    const overlay = document.createElement("div");
    overlay.classList.add("mathbox-overlay");
    this.element.appendChild(overlay);
    return this.overlay = overlay;
  }
  unmount(_overlay) {
    if (this.overlay && this.overlay.parentNode) {
      this.element.removeChild(this.overlay);
    }
    return this.overlay = null;
  }
  render(el) {
    if (!this.overlay) {
      this.mount();
    }
    if (["string", "number"].includes(typeof el)) {
      el = this.el("div", null, el);
    }
    if (el instanceof Array) {
      el = this.el("div", null, el);
    }
    if (el == null) {
      el = this.el("div");
    }
    const naked = el.type === "div";
    let {last} = this;
    const {overlay} = this;
    const node = naked ? overlay : overlay.childNodes[0];
    const parent = naked ? overlay.parentNode : overlay;
    if (!last && node) {
      last = this.el("div");
    }
    this.apply(el, last, node, parent, 0);
    this.last = el;
    if (last != null) {
      this.recycle(last);
    }
  }
}
DOM.initClass();

};